import {
    Announced,
    CommandBar,
    ConstrainMode,
    DetailsListLayoutMode,
    getTheme,
    IColumn,
    ICommandBarItemProps,
    IDetailsHeaderProps,
    IDetailsRowProps,
    IRenderFunction,
    Label,
    mergeStyleSets,
    ScrollablePane,
    Selection,
    SelectionMode,
    ShimmeredDetailsList,
    Stack,
    Sticky,
} from '@fluentui/react';

export interface IGridSelectorProps {
    selection: Selection;
    label?: string;
    ariaLabelForGrid?: string;
    columns: IColumn[];
    items: any[];
    selectionDetails: string;
    errorMessage?: string;
    width?: string | number;
    height?: string | number;
    onRenderItemColumn?: any;
    selectionMode?: SelectionMode;
    commandBarItems?: ICommandBarItemProps[];
    showShimmer?: boolean;
}

const theme = getTheme();

export function CompactSelectGridFixedHeaders(props: IGridSelectorProps) {
    if (!props.items) return null;

    const classNames = mergeStyleSets({
        message: {
            display: 'block',
            marginBottom: '5px',
            marginTop: '5px',
            color: props.errorMessage ? theme.palette.redDark : theme.palette.neutralPrimary,
            fontSize: props.errorMessage ? '12px' : '14px',
        },
        wrapper: {
            height: props.height ? props.height : '50vh',
            position: 'relative',
            width: props.width ? props.width : 400,
        },
    });

    const selectionMode = props.selectionMode ?? SelectionMode.multiple;
    const handleRenderRow = (props?: IDetailsRowProps, defaultRender?: IRenderFunction<IDetailsRowProps>): JSX.Element => {
        return <div data-selection-toggle>{defaultRender && defaultRender(props)}</div>;
    };

    return (
        <Stack>
            {!!props.label && <Label>{props.label}</Label>}
            <div className={classNames.message}>{!props.errorMessage ? props.selectionDetails : props.errorMessage}</div>
            <Announced message={!props.errorMessage ? props.selectionDetails : props.errorMessage} />
            {props.commandBarItems && <CommandBar onReduceData={() => undefined} items={props.commandBarItems} />}
            <div className={classNames.wrapper}>
                <ScrollablePane>
                    <ShimmeredDetailsList
                        ariaLabelForGrid={props.ariaLabelForGrid ?? props.label}
                        ariaLabelForShimmer="Content is being fetched"
                        constrainMode={ConstrainMode.unconstrained}
                        compact={true}
                        items={props.items}
                        columns={props.columns}
                        setKey="set"
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        selection={props.selection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={selectionMode}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                        checkButtonAriaLabel="select row"
                        enterModalSelectionOnTouch={false}
                        onRenderDetailsHeader={(
                            detailsHeaderProps?: IDetailsHeaderProps,
                            defaultRender?: IRenderFunction<IDetailsHeaderProps>
                        ) => <Sticky>{defaultRender!(detailsHeaderProps)}</Sticky>}
                        onRenderItemColumn={props.onRenderItemColumn || undefined}
                        onRenderRow={selectionMode === SelectionMode.multiple ? handleRenderRow : undefined}
                        selectionZoneProps={
                            selectionMode === SelectionMode.multiple
                                ? {
                                      selection: props.selection,
                                      selectionClearedOnSurfaceClick: false,
                                  }
                                : undefined
                        }
                        enableShimmer={props.showShimmer}
                    />
                </ScrollablePane>
            </div>
        </Stack>
    );
}
